module.exports = __webpack_public_path__ + "img/Knitting_1200x800.c83fbd28.png";